import moment from "moment";
import constants from "../../../core/constants";

class Controller {
  constructor($injector, $mdDialog, customer, Events) {
    "ngInject";

    this.$mdDialog = $mdDialog;
    this.customer = customer;
    this.Currency = $injector.get("Currency");
    this.City = $injector.get("City");
    this.currency = this.customer.city.currency;
    this.Events = Events;
    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;
  }
  $onInit() {
    this.Currency.getAll({ isCityRequired: false }).$promise.then(
      (response) => {
        this.currencies = response.currencies;
      },
      (response) => this.Events.emit(this.errorNotificationEvent, response.data)
    );
  }
  close() {
    this.$mdDialog.cancel();
  }

  confirm() {
    const options = {};
    options.amount = this.amount;
    options.currency = this.currency;
    options.comment = this.comment;
    options.expiry_date = this.expiryDate
      ? Number(moment(this.expiryDate).format(constants.unixFormat))
      : null;
    options.type = this.type || "topup";

    this.$mdDialog.hide(options);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/customer/dialog/dialog.controller.js